import reviewsData from '@/data/google-reviews.json';

type Review = (typeof reviewsData.reviews)[number];

const featured: Review[] = reviewsData.featuredForSite
  .map((id) => reviewsData.reviews.find((r) => r.id === id))
  .filter((r): r is Review => Boolean(r && r.text && r.text.length > 40));

export default function Testimonials() {
  return (
    <section id="avis" className="py-16 px-6 scroll-mt-[84px] bg-white">
      <div className="max-w-[1180px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-[#0b6b52] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Avis Google
          </span>
          <h2
            className="text-[clamp(28px,4vw,40px)] font-bold text-[#173029] mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Ce que disent nos patients
          </h2>
          <p className="text-[#57534a] text-sm max-w-xl mx-auto">
            Avis authentiques laissés sur Google — hygiène, écoute et résultats concrets.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.slice(0, 6).map((t) => (
            <div
              key={t.id}
              className="bg-[#f6f3ec] border border-[#e8e2d4] rounded-2xl p-6 flex flex-col"
            >
              <div className="flex gap-0.5 mb-3" aria-label={`${t.rating} étoiles`}>
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-sm"></i>
                ))}
              </div>
              <p className="text-[#57534a] text-sm leading-relaxed flex-1 mb-5">
                « {t.text} »
              </p>
              <div className="flex items-center justify-between gap-3 pt-3 border-t border-[#e8e2d4]">
                <div>
                  <div className="text-[#173029] font-semibold text-sm">{t.author}</div>
                  {t.visited && (
                    <div className="text-[#8a8578] text-xs mt-0.5">Visité en {t.visited}</div>
                  )}
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-[#0b6b52] bg-[#0b6b52]/10 px-2 py-1 rounded-full whitespace-nowrap">
                  Google
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
